'use client';

import { EventData } from '../types';
import { useEffect, useRef } from 'react';
import { trackEvent } from '../core';

export const useTrackEventOnce = (event: EventData | undefined) => {
  let tracked = useRef(false);

  useEffect(() => {
    if (tracked.current || typeof event === 'undefined') {
      return;
    }

    tracked.current = true;

    trackEvent(event);
  }, [event]);
};
